<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Напоминания') }}</h1>

                    <div class="reminders-total-amount">
                        {{ $t('reminders_month_amount') }}: <b>{{ amount | money }}</b> <span class="currency">{{ currency | currency }}</span>
                    </div>
                </div>

                <div class="reminders-container">
                    <div class="reminders-total-amount mobile">
                        {{ $t('reminders_month_amount') }}: <b>{{ amount | money }}</b> <span class="currency">{{ currency | currency }}</span>
                    </div>

                    <ReminderWidgetItem @open="openReminder(reminder)" :reminder="reminder" v-for="reminder in reminders.actual" :key="reminder.id" />
                </div>
                <div class="reminders-container reminders-completed">
                    <ReminderWidgetItem @open="openReminder(reminder)" :reminder="reminder" v-for="reminder in reminders.completed" :key="reminder.id" />
                </div>
            </div>

            <div class="right-side-container sticky">
                <RightSideUserControls />

                <ReminderForm />
            </div>
        </div>
        
        <MobilePlusBtn type="new-reminder" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";
import ReminderWidgetItem from "@/new/components/Reminders/ReminderWidgetItem.vue";
import ReminderForm from "@/new/components/Reminders/ReminderForm.vue";
import { EventBus } from '../../../event-bus';

export default {
    name: "Reminders",

    components: {
        ReminderWidgetItem,
        RightSideUserControls,
        ReminderForm,
        MobilePlusBtn
    },

    data: function() {
        return {
            amount: 0,
            currency: null,
        };
    },

    mounted() {
        this.loadCategories();
        this.loadReminders();
        this.loadCurrentAmount();

        EventBus.$on('reminders-update-amount', this.loadCurrentAmount);
    },

    computed: {
        ...mapGetters(['categories', 'reminders', 'isRemindersLoaded']),
    },

    methods: {
        ...mapActions(['loadCategories', 'loadReminders']),

        openReminder(reminder) {
            EventBus.$emit('open-side-form', 'edit-reminder', {reminder: reminder});
        },

        loadCurrentAmount() {
            axios.get('/reminders/amount')
                .then(({data}) => {
                    this.amount = data.data.value;
                    this.currency = data.data.currency;
                }).catch(({response}) => {
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка при загрузке данных'), 'error');
                });
        },
    }
}
</script>

<style scoped lang="scss">
.right-side-container {
    @media (max-width: 768px) {
        display: none;
    }
}

.reminders-total-amount {
    font-size: 14px;
    opacity: 0.7;

    b {
        margin-left: 2px;
    }

    &.mobile {
        padding: 15px 15px 5px;
        font-size: 16px;

        @media (min-width: 768px) {
            display: none;
        }
    }
}

.reminders-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    &.reminders-completed {
        margin-top: 15px;
        border-top: 1px solid rgba(#152640, .1);
        padding-top: 15px;
    }

    .reminder-item { 
        background: #fff;
        border-radius: 5px;
        padding: 15px 15px;
        margin: 0;
        border-top: none;

        cursor: pointer;

        width: calc(50% - 40px);

        @media (max-width: 768px) {
            border-radius: 0;
            width: 100%;

            &:first-child {
                margin-top: 20px;
            }
        }
    }
}
</style>